import React from "react";
import { Modal,Spinner } from "react-bootstrap";
import {Form} from "react-bootstrap";
import "../../containers/ControlMeasures/ControlMeasures.css";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import InputComponent from "../UI/InputComponent/InputComponent";
import ModalComponent from "../UI/Modal/Modal";

const Napomena = (props) => {

  return (
    <>
      <ModalComponent
        size="l"
        show={props.modalNapomena}
        onHide={props.hideModalNapomena}
        className="heder"
        centered
        title="Ažuriranje napomene"
      >
        <Modal.Body>
          <div className="justify-content-center" key={"form"}>
            <div className="align-self-center modal-mjere">
              <Form onSubmit={props.submitHandlerNapomena}>
               <div>

                <InputComponent
                  id="napomena"
                  value={props.napomena}
                  onChange={props.userInputNapomena}
                  controlLabel={"Napomena"}
                  className="input-modal"
                  name="napomena"
                />
                </div>

                <div className="row" key={"button"}>
                  <div className="col-md-6">
                    <ButtonComponent
                      type="submit"
                      block={true}
                      variant="primary"
                    >
                      Spremi
                    </ButtonComponent>
                  </div>
                  <div className="col-md-6">
                    <ButtonComponent
                      onClick={props.hideModalNapomena}
                      block={true}
                      variant="danger"
                    >
                      Odustani
                    </ButtonComponent>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </Modal.Body>
      </ModalComponent>
    </>
  )
}

export default Napomena
